import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Button from '../../../components/General/Button'
import CurrencyInput from '../../../components/Inputs/CurrencyInput'
import Datepicker from '../../../components/Inputs/Datepicker'
import InputNumber from '../../../components/Inputs/InputNumber'
import InputText from '../../../components/Inputs/InputText'
import Select from '../../../components/Inputs/Select'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import { formatPipe, getDenomination } from '../../../utils/utils'

const server = process.env.REACT_APP_SERVER_URL

const AddPaymentFormModal : React.FC<IPurchaseHistoric> = ({onSubmit, purchaseDate, onClose}) => {
  const form = useForm({defaultValues: {amount: 0}})
  const today = DateTime.local().setLocale('es')

  const [accounts, setAccounts] = useState<any[]>([])

  const [selectedAccount, setSelectedAccount] = useState<any | null>(null)

  const [accountsGlobal, setAccountsGlobal] = useState<any[]>([])

  const { addAlert } = useSnackBars()

  const getAccounts = async (): Promise<void> => {
    let response = await axios.get(`${server}/finances/account`)
    setAccounts(
      response.data.accounts.map((v) => ({
        text: v?.description,
        value: v?.id,
      }))
    )

    setAccountsGlobal(response.data.accounts)

    setSelectedAccount({
      account: {
        text: response?.data?.accounts[0]?.description,
        value: response?.data?.accounts[0]?.id,
        currency: response?.data?.accounts[0]?.idCurrency,
      },
      date: `${today.year}/${today.month}/${today.day}`,
    })
  }

  useEffect(() => {
    getAccounts()
  }, [])
  
  return (
    <div>
      <Form classes="gap-x-6 gap-y-2" form={form} onSubmit={(values) => {

        // let date1 = `${today.year}-${+today.month < 10 ? `0${today.month}` : today.month}-${+today.day < 10 ? `0${today.day}` : today.day}`

        let [day1, month1, year1] = purchaseDate?.split("/")

        let date1 = new Date(+year1, +month1-1, +day1).toISOString().replace(/T.+/, "")

        let [day, month, year] = values?.date?.split("/")

        let date2 = new Date(+year, +month-1, +day).toISOString().replace(/T.+/, "")

        let d1 = DateTime.fromISO(date1)

        let d2 = DateTime.fromISO(date2)

        if (d2 > d1) {
          addAlert({
            message: 'La fecha de pago no puede ser mayor a la fecha de compra.',
            status: 'error',
          })
        } else {
          onSubmit({...values, amount: formatPipe(values?.amount, true), reference: values?.reference || "N/A"}, selectedAccount)
        }

      }}>
        <FormItem
          name="account"
          rules={{ required: 'Es necesario el campo' }}
          classes="col-span-12 xl:col-span-6"
        >
          <Select label='Cuenta' value={selectedAccount?.account} options={accounts} onChange={(values) => {
            let currency = accountsGlobal.find(
                (v) => v?.id === values?.value
              )?.idCurrency
              // console.log('currency', currency)
              if (values) {
                values.currency = currency
              }
              // values.currency = currency
              setSelectedAccount((prevState) => ({
                ...prevState,
                account: values,
              }))
          }} />
        </FormItem>

        <FormItem
          name="amount"
          rules={{ required: 'Es necesario el campo' }}
          classes="col-span-12 xl:col-span-6"
        >
          {/* <InputNumber isUpperValue={false} label="Monto" /> */}
          <CurrencyInput label='Monto' addDecimals={true} mask={`${getDenomination(selectedAccount?.account?.currency)}${selectedAccount?.account?.currency === 2 ? '.' : ''} num`} />
        </FormItem>

        <FormItem
          name="date"
          rules={{ required: 'Es necesario el campo' }}
          classes="col-span-12 xl:col-span-6 mt-1"
        >
          <Datepicker label='Fecha' />
        </FormItem>

        <FormItem
          name="reference"
          classes="col-span-12 xl:col-span-6"
        >
          <InputText isUpperValue={false} label="Referencia" />
        </FormItem>

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                if (onClose) onClose()
              }}
              type="outline"
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button
              type="primary"
              classes="w-full"
              htmlType="submit"
            >
              {'Añadir'}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

interface IPurchaseHistoric {
    onSubmit: Function    
    purchaseDate: String
    onClose: () => void
}

export default AddPaymentFormModal
